import { signout } from "@/api/passport"
import { COOKIE_DOMAIN, TokenKey, ExpiresInKey, UserNameKey, NHTokenKey } from "@/constants/config"
import Cookies from "@/util/cookies"
import { createModel } from "hox"
import { useCallback, useMemo, useState } from "react"

export type User = {
  authorization_token?: string
  ktoken?: string
  userRole?: string
  user_name?: string
  name?: string // 农行环境
  user_type?: string
  oauth_uname?: string
  expires?: number | string | Date
  [propName: string]: any
}
const userKeys = [
  "ktoken",
  "userRole",
  "name",
  "user_type",
  "oauth_name",
  TokenKey,
  ExpiresInKey,
  UserNameKey,
]

function useUser() {
  const [userInfo, setUserInfo] = useState<User>({})
  const updateUser = useCallback(
    (user) => {
      // FN_CALLBACK_LOGIN(user)
      setUserInfo(user)
    },
    [setUserInfo],
  )
  const login = useCallback(
    (user: User) => {
      Object.keys(user).forEach((sKey) => {
        Cookies.setItem(sKey, user[sKey], "/", user[ExpiresInKey], COOKIE_DOMAIN)
      })
      updateUser(user)
    },
    [updateUser],
  )

  const logout = useCallback(
    async (callback?: VoidFunction) => {
      await signout()
      Object.keys(userInfo).forEach((sKey) => {
        Cookies.removeItem(sKey, "/", COOKIE_DOMAIN)
      })
      updateUser({})
      callback?.()
    },
    [updateUser, userInfo],
  )

  useMemo(() => {
    const cookies = Cookies.parsedCookies()
    const user: any = {}
    if (cookies) {
      userKeys.forEach((k) => {
        if (cookies[k]) {
          user[k] = cookies[k]
        }
      })
    }
    ;(user[TokenKey] || user[NHTokenKey]) && updateUser(user)
  }, [updateUser])
  return {
    userInfo,
    login,
    logout,
    updateUser,
  }
}

export default createModel(useUser)
